import SectionCard from "@/components/common/SectionCard";
import { Skeleton } from "@/components/ui/skeleton";

interface HelpArticlesSkeletonProps {
  rows?: number;
}

// Mirrors the article row in HelpCenter: numbered badge, question + category
// stack, trailing chevron. Widths vary per row so it reads as text, not bars.
const WIDTHS = ["w-56", "w-72", "w-64", "w-48", "w-60"];

export default function HelpArticlesSkeleton({ rows = 5 }: HelpArticlesSkeletonProps) {
  return (
    <SectionCard contentClassName="p-0" role="status" aria-label="Loading articles" data-testid="help-center-articles-skeleton">
      {Array.from({ length: rows }, (_, index) => (
        <div
          key={index}
          className={index > 0 ? "flex items-center gap-4 border-t border-dash-border px-4 py-4 sm:px-5" : "flex items-center gap-4 px-4 py-4 sm:px-5"}
        >
          <Skeleton className="size-7 shrink-0 rounded-xl" />
          <div className="min-w-0 flex-1 space-y-2">
            <Skeleton className={`h-4 max-w-full ${WIDTHS[index % WIDTHS.length]}`} />
            <Skeleton className="h-3 w-24" />
          </div>
          <Skeleton className="size-4 shrink-0 rounded" />
        </div>
      ))}
      <span className="sr-only">Loading articles…</span>
    </SectionCard>
  );
}
